import reportsConfig from '~/constants/data-reports/lithium'

export default {
  hero: reportsConfig.hero,
  descriptions: [
    'Understanding the specialist nature of lithium is crucial to our data collection process. Our team are in constant contact with major actors in the lithium supply chain.',
  ],
  descriptionImage:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/q_auto,f_auto/v1718206075/assets/market/Lithium/desc_banner_zygs9w.png',
  services: [
    {
      icon: 'services/icon-chart-line',
      description:
        'Create your own custom pricing charts using our bespoke data.',
    },
    {
      icon: 'services/icon-presentation',
      description:
        'Produce custom made representations of data to download for projects and presentations.',
    },
    {
      icon: 'services/icon-consultancy',
      description:
        'Access Benchmark’s exclusive industry commentary collected through our extensive network of industry contacts.',
    },
    {
      icon: 'services/icon-idea',
      description:
        'Our goal is to help you understand the context of our data, not just give you the numbers.',
    },
  ],
  logo: 'lithium-logo',
  videoId: 'ToUzTQrgxzQ',
  videoProvider: 'youtube',
  brochureFile: {
    file_name: 'Benchmark-Lithium-Price-Assessment-Methodology.pdf',
    category: 'methodology-price-assessments',
    EnvKey: 'lithiumPriceAssessmentsMethodologyId',
  },
  indexTab: true,
  customisationToolTab: true,
  requiredFilters: ['categories', 'purities', 'priceTypes'],
}
